import { RegisterNewCompanyWithConnectBoardMutation } from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

// Mock Payloads
const successRegistrationPayload = {
  registerNewCompanyWithConnectBoard: {
    token: {
      access_token: "", // サインインで取得したトークンを入れる
      id_token: "",
      refresh_token: "",
      token_type: "Bearer",
    },
  },
};

const errorRegistrationFailedPayload = {
  registerNewCompanyWithConnectBoard: {
    token: null,
  },
};

const errorUsernameExistsPayload = {
  errors: [
    {
      extensions: {
        code: ErrorCode[ErrorCode.USERNAME_EXISTS],
      },
    },
  ],
};

// Mock Cases
enum RegisterNewCompanyWithConnectBoardMockCase {
  SuccessRegistration,
  ErrorUsernameExists,
}
const targetCase =
  RegisterNewCompanyWithConnectBoardMockCase.ErrorUsernameExists; // ここでモックのケースを変更する

export const registerNewCompanyWithConnectBoardHandler =
  graphql.mutation<RegisterNewCompanyWithConnectBoardMutation>(
    "registerNewCompanyWithConnectBoard",
    ({ query, variables }) => {
      switch (Number(targetCase)) {
        case RegisterNewCompanyWithConnectBoardMockCase.SuccessRegistration:
          return HttpResponse.json({
            data: successRegistrationPayload,
          });
        case RegisterNewCompanyWithConnectBoardMockCase.ErrorUsernameExists:
          return HttpResponse.json({
            data: errorRegistrationFailedPayload,
            errors: errorUsernameExistsPayload.errors,
          });
      }
    }
  );
